import { ProviderFundsPage } from '../providerFunds/ProviderFundsPage';
import { PROVIDERS_ASSETS_CONFIG } from '../providerFunds/config';

export function ProvidersAssetsPage() {
  return <ProviderFundsPage config={PROVIDERS_ASSETS_CONFIG} />;
}
